import { defineComponent as h, computed as f, openBlock as o, createBlock as s, resolveDynamicComponent as r, mergeProps as b, withCtx as g, unref as v, createCommentVNode as n, renderSlot as x } from "vue";
import { I as y } from "./IconLoader2-tUjfbfXu.js";
const k = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    as: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    iconLeft: { default: void 0 },
    iconRight: { default: void 0 }
  },
  emits: ["click"],
  setup(e, { emit: d }) {
    const a = e, l = d, c = (t) => {
      !a.disabled && !a.loading && l("click", t);
    }, m = f(() => {
      const t = [], i = {
        primary: [
          "bg-primary",
          "text-primary-content",
          "shadow-sm",
          "hover:bg-primary/90",
          "hover:shadow-md"
        ],
        secondary: [
          "bg-secondary",
          "text-secondary-content",
          "shadow-sm",
          "hover:bg-secondary/90",
          "hover:shadow-md"
        ],
        neutral: [
          "bg-bg-card",
          "text-text-main",
          "shadow-sm",
          "border",
          "border-neutral-200",
          "hover:border-accent-soft",
          "hover:text-accent",
          "hover:shadow-md"
        ],
        outline: [
          "bg-transparent",
          "border-2",
          "border-text-main",
          "text-text-main",
          "hover:bg-neutral-50"
        ],
        soft: ["bg-accent-soft", "text-accent", "hover:shadow-sm"],
        ghost: [
          "bg-transparent",
          "text-text-muted",
          "hover:bg-neutral-100",
          "hover:text-text-main",
          "hover:shadow-sm"
        ],
        danger: [
          "bg-error",
          "text-white",
          "shadow-sm",
          "hover:bg-red-600",
          "hover:shadow-md"
        ]
      }, u = {
        sm: ["px-3", "py-1.5", "text-xs"],
        md: ["px-5", "py-2.5", "text-sm"],
        lg: ["px-6", "py-3", "text-base"]
      };
      return a.variant && t.push(...i[a.variant]), a.size && t.push(...u[a.size]), a.fullWidth && t.push("w-full"), t;
    });
    return (t, i) => (o(), s(r(e.as), b({
      class: ["inline-flex items-center justify-center font-medium transition-colors duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed relative focus-ring rounded-button shrink-0", m.value],
      disabled: e.disabled || e.loading
    }, t.$attrs, { onClick: c }), {
      default: g(() => [
        e.loading ? (o(), s(v(y), {
          key: 0,
          class: "animate-spin mr-2 h-4 w-4"
        })) : n("", !0),
        e.iconLeft && !e.loading ? (o(), s(r(e.iconLeft), {
          key: 1,
          class: "mr-2 h-4 w-4"
        })) : n("", !0),
        x(t.$slots, "default"),
        e.iconRight ? (o(), s(r(e.iconRight), {
          key: 2,
          class: "ml-2 h-4 w-4"
        })) : n("", !0)
      ]),
      _: 3
    }, 16, ["class", "disabled"]));
  }
});
export {
  k as _
};
